import { UvProvider } from '../providers/uvProvider.js';

export const GET_UV_BY_LATLON = 'GET_UV_BY_LATLON';
export const GET_UV_BY_LATLON_PENDING = 'GET_UV_BY_LATLON_PENDING';
export const GET_UV_BY_LATLON_FULFILLED = 'GET_UV_BY_LATLON_FULFILLED';
export const GET_UV_BY_LATLON_REJECTED = 'GET_UV_BY_LATLON_REJECTED';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';

export function getUvByLatLon(...params) {
    let paramsObject = {
        latitude: undefined,
        longitude: undefined,
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        stdParameters: undefined
    };
    paramsObject = mapParamsToObject(params, paramsObject);
    return {
        type: GET_UV_BY_LATLON,
        payload: getUv(paramsObject)
    };
}

async function getUv({ latitude, longitude, baseUrl, authId, secret, stdParameters }) {
    const op = new UvProvider(baseUrl, authId, secret);
    return await op.getUv(latitude, longitude, stdParameters);
}
